/*
 * El Cabron image-zoom for Ride's <product-modal> lightbox.
 * Active on the el-cabron template only (loaded conditionally from
 * snippets/cart-notification.liquid).
 *
 * Click an image inside the open modal to toggle a 2x zoom centered
 * on the click point. Click again to zoom back out. Wheel events
 * are not intercepted — vertical scroll through the stacked media
 * items keeps working at all times. Resets on close via a
 * MutationObserver on the modal's `open` attribute (Ride removes
 * that attribute on Escape, close-button click, and click-outside).
 *
 * No touch support — mobile uses the static fit-to-viewport view.
 */
(function () {
  function init() {
    const modal = document.querySelector('.product-media-modal');
    if (!modal) return;

    function clearZoom() {
      modal.querySelectorAll('img.is-zoomed, video.is-zoomed').forEach((el) => {
        el.classList.remove('is-zoomed');
        el.style.transformOrigin = '50% 50%';
      });
    }

    // Ride's <product-modal> has a `pointerup` listener (assets/global.js:609)
    // that closes the modal on any mouse pointerup that isn't inside a
    // <deferred-media> or <product-model>. pointerup fires before click,
    // so without this capture-phase guard the modal closes the moment the
    // user releases the mouse on an image and our click-to-zoom never gets
    // to run. Stopping propagation in the capture phase prevents Ride's
    // bubble-phase listener from firing for clicks on images; clicks on
    // the surrounding black background still close the modal normally.
    modal.addEventListener(
      'pointerup',
      (event) => {
        if (event.target.closest('img, video')) {
          event.stopPropagation();
        }
      },
      true
    );

    modal.addEventListener('click', (event) => {
      const target = event.target.closest('img, video');
      if (!target) return;

      if (target.classList.contains('is-zoomed')) {
        target.style.transformOrigin = '50% 50%';
        target.classList.remove('is-zoomed');
        return;
      }

      // Set the transform origin to the click position before adding
      // the .is-zoomed class so the scale animates outward from
      // where the user clicked.
      const rect = target.getBoundingClientRect();
      const originX = ((event.clientX - rect.left) / rect.width) * 100;
      const originY = ((event.clientY - rect.top) / rect.height) * 100;
      target.style.transformOrigin = `${originX}% ${originY}%`;
      target.classList.add('is-zoomed');
    });

    // Reset zoom whenever the modal closes.
    const observer = new MutationObserver(() => {
      if (!modal.hasAttribute('open')) clearZoom();
    });
    observer.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
